<template>
    <router-link v-if="!disabled" :id="idPosition" :to="{ name: to }">
        <slot/>
    </router-link>
    <router-link v-else :id="idPosition" :to="{ name: 'access-denied' }" class="bg-secondary">
        <slot/>
    </router-link>
</template>
  
  <script>

  export default {
    name: 'OptionalRouterLink',
  
    props: {
      params: Object,
      to: String,
      idPosition: String, 
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };

  </script>